export const DEFAULT_API_V1_BASE = "http://localhost:8000/api/v1";

export const API_REQUEST_DEFAULTS = Object.freeze({
  configurationTimeoutMs: 20000,
});

export const API_PATH = Object.freeze({
  questionnaireInitialize: "/api/v1/questionnaires/frontend/initialize/",
  questionnaireComplete: "/api/v1/questionnaires/frontend/complete/",
  questionnaireStatus: (sessionToken) =>
    `/api/v1/questionnaires/frontend/status/${sessionToken}/`,
  questionnaireSaveDraft: "/api/v1/questionnaires/frontend/save-draft/",
  questionnaireGetDraft: "/api/v1/questionnaires/frontend/get-draft/",
  questionnairePaymentConfig:
    "/api/v1/questionnaires/frontend/payment-config/",
  questionnaireAvailableStates:
    "/api/v1/questionnaires/config/available-states/",
  couponValidate: "/api/v1/coupons/validate/",
  questionnaireProductResolve: "/api/v1/questionnaires/products/resolve/",
  patientOnboarding: "/api/patient/onboarding/",
  orderCreate: "/api/order/create/",
  checkout: (checkoutToken) => `/api/checkout/${checkoutToken}/`,
  checkoutPay: (checkoutToken) => `/api/checkout/${checkoutToken}/pay/`,
  combinedCheckout: "/api/v1/orders/combined-checkout/",
  combinedCheckoutPaymentMethods: "/api/v1/orders/combined-checkout/payment-methods/",
  combinedCheckoutRecovery: (token) =>
    `/api/v1/orders/combined-checkout/recovery/${token}/`,
  checkoutPaymentMethod: (checkoutToken, paymentMethodId) =>
    `/api/checkout/${checkoutToken}/payment-methods/${paymentMethodId}/`,
  checkoutPaymentMethods: (checkoutToken) =>
    `/api/checkout/${checkoutToken}/payment-methods/`,
  checkoutRefreshToken: "/api/checkout/refresh-token/",
  embedToken: "/api/embed-token",
  visitConfig: (visitType) =>
    `/api/v1/medical/visits/${visitType}/config/`,
  followUpVerify: "/api/v1/questionnaires/follow-ups/verify/",
  followUpInfo: (sessionId) =>
    `/api/v1/questionnaires/follow-ups/${sessionId}/info/`,
});

export const joinApiEndpoint = (baseUrl, path) =>
  `${String(baseUrl || "").replace(/\/+$/, "")}${path}`;

export const normalizeApiV1Base = (baseUrl) => {
  const normalized = String(baseUrl || "").replace(/\/+$/, "");
  return /\/api\/v1$/i.test(normalized)
    ? normalized
    : `${normalized}/api/v1`;
};

export const joinApiV1Endpoint = (baseUrl, path) =>
  `${normalizeApiV1Base(baseUrl)}${String(path).replace(/^\/api\/v1/i, "")}`;
